module.exports = __webpack_public_path__ + "img/about-Open.0256976d.png";